import { createFileRoute } from '@tanstack/react-router'
import { StaffOverviewPage } from '@/features/scheduler/pages/staff-overview-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/overview'
)({
  component: StaffOverviewPage,
})
